import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getHistoryAudit = createAsyncThunk('/historyaudit/content', async (nopage) => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listHistoryAudit/${userId}?page=${nopage}`, {})
    return response.data;
})

export const historyauditSlice = createSlice({
    name: 'historyaudit',
    initialState: {
        isLoading: false,
        historyaudit : []
    },
    reducers: {


        addNewHistoryaudit: (state, action) => {
            let {newHistoryauditObj} = action.payload
            state.historyaudit = [...state.historyaudit, newHistoryauditObj]
        },

        deleteHistoryaudit: (state, action) => {
            let {index} = action.payload
            state.historyaudit.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getHistoryAudit.pending]: state => {
			state.isLoading = true
		},
        [getHistoryAudit.fulfilled]: (state, action) => {
            state.historyaudit = action.payload.data
			state.isLoading = false
		},
        [getHistoryAudit.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getHistoryAudit.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getHistoryAudit.fulfilled, (state, action) => {
            state.historyaudit = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getHistoryAudit.rejected, (state) => {
            state.isLoading = false;
          });                       
        }
})

export const { addNewHistoryaudit, deleteHistoryaudit } = historyauditSlice.actions

export default historyauditSlice.reducer